const TONE = {
  positive: "bg-emerald-100 text-emerald-900 border-emerald-200",
  neutral: "bg-stone-100 text-stone-800 border-stone-200",
  warning: "bg-amber-100 text-amber-900 border-amber-200",
  brand: "bg-[#B85F2A]/12 text-[#8a4820] border-[#B85F2A]/30",
};

// LABEL_META maps a trust-label key → {label, tone}. Kept in sync with the
// server catalog (/api/nature/trust-labels).
const LABEL_META = {
  "user-observation": { label: "User Observation", tone: "neutral" },
  "ai-suggested": { label: "AI Suggested", tone: "neutral" },
  "community-identified": { label: "Community Identified", tone: "neutral" },
  "moderator-reviewed": { label: "Moderator Reviewed", tone: "positive" },
  "expert-verified": { label: "Expert Verified", tone: "positive" },
  "official-source": { label: "Official Source", tone: "positive" },
  "unverified-report": { label: "Unverified Report", tone: "warning" },
  "witness-report": { label: "Witness Report", tone: "neutral" },
  "officially-confirmed": { label: "Officially Confirmed", tone: "positive" },
  "trusted-contributor": { label: "Trusted Contributor", tone: "brand" },
};

/**
 * TrustBadges — small strip of provenance chips shown on observation cards
 * and detail pages. Keeps community observations visibly distinct from
 * moderated / expert-verified / official records.
 */
export default function TrustBadges({ labels = [], size = "sm", className = "" }) {
  if (!labels?.length) return null;
  const px = size === "xs" ? "px-1.5 py-0.5 text-[9px]" : "px-2 py-0.5 text-[10px]";
  return (
    <div className={`flex flex-wrap gap-1 ${className}`} data-testid="trust-badges">
      {labels.map((k) => {
        const meta = LABEL_META[k] || { label: k, tone: "neutral" };
        return (
          <span
            key={k}
            data-testid={`trust-${k}`}
            className={`inline-flex items-center rounded-full ${px} border font-mono-tech tracking-[0.2em] uppercase ${TONE[meta.tone]}`}
          >
            {meta.label}
          </span>
        );
      })}
    </div>
  );
}
